import { render, staticRenderFns } from "./MultipleImage.vue?vue&type=template&id=1861f271"
import script from "./MultipleImage.vue?vue&type=script&lang=js"
export * from "./MultipleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports